import { QuoteToolPreselectedModes } from '@lx/shared/utils';
import { z } from 'zod';
import { optionalDateSchema } from './optional-date.schema';

/**
 * Schema for representing the parameters of the Study and Stay deep link in Quote Tool Lite.
 * It validates the parameters from BaseCourseDeepLinkParameters.
 */
export const StudyAndStayDeepLinkParametersSchema = z
  .object({
    preselectedMode: z.nativeEnum(QuoteToolPreselectedModes),
    schoolCode: z.string(),
    courseCode: z.string(),
    duration: z.number().min(1),
    startDate: optionalDateSchema,
    deeplinkType: z.string(),
  })
  .partial()
  .required({
    preselectedMode: true,
    schoolCode: true,
    courseCode: true,
  });
